<template>
  <v-app>
    <v-app-bar
      app
      dense
      flat
      color='#111025'
    >
      <div class='mod pl-3'>DOM</div>
      <v-spacer></v-spacer>
      <div class='links d-none d-md-flex'>
        <a href='#home'>Home</a>
        <a href='#about'>About</a>
        <!-- <a href='#history'>History</a> -->
        <a href='#portfolio'>Projects</a>
        <a href='#contact'>Contact</a>
      </div>
      <v-menu bottom>
        <template v-slot:activator='{ on, attrs }'>
          <v-btn class='d-flex d-md-none'
          color='rgb(119, 103, 209)'
          text
          v-on=on
          v-bind=attrs>
            <v-icon>mdi-menu</v-icon>
          </v-btn>
        </template>
        <v-list class='' color='#111025'>
          <v-list-item v-for='(link, idx) in links' :key=idx :href=link.to>
            <v-list-item-title>{{link.title}}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>

    <v-main>
      <Intro id='home' />
      <AboutMe id='about' />
      <!-- <MyHistory id='history' /> -->
      <MyPortfolio id='portfolio' />
      <MyContact id='contact' />
    </v-main>
  </v-app>
</template>

<script>
import Intro from './components/Intro.vue'
import AboutMe from './components/AboutMe.vue'
import MyPortfolio from './components/MyPortfolio.vue'
import MyContact from './components/MyContact.vue'
export default {
  name: 'App',
  components: {
    Intro,
    AboutMe,
    MyPortfolio,
    MyContact
  },
  data: () => ({
    links: [
      {title: 'Home', to: '#home'},
      {title: 'About', to: '#about'},
      // {title: 'History', to: '#history'},
      {title: 'Projects', to: '#portfolio'},
      {title: 'Contact', to: '#contact'},
    ]
  }),
};
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;700;900&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Lora&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Acme&display=swap');
:root {
  --primary: #ff0077;
  --primary1: #30343f;
  --paragraph: #6e6e6e;
  --body: #ebebeb;
  --lora: 'Lora', serif;
  --poppins: 'Poppins', sans-serif;
  --acme: 'Acme', sans-serif;
}
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}
/* typography */
h5 {
  color: var(--primary);
  font-family: 'Poppins', sans-serif;
  font-size: 1rem;
  letter-spacing: 1.5px;
}
a {
  text-decoration: none;
}
.pink-primary {
  color: var(--primary)
}
.mod {
  color: #ebebeb;
  font-family: var(--lora);
  font-size: 1.5rem;
  font-weight: 700;
  letter-spacing: .2rem;
}
/*  */
section.header {
  text-align: center;
}
.links > a {
  color: rgb(140, 128, 207) !important;
  /* color: red; */
  font-family: var(--poppins);
  padding: 0 20px
}

.links > a:active{
  color: rgb(238, 105, 156) !important;
}

.links > a:hover,
.v-list-item__title:hover {
  color: rgb(221, 217, 248) !important;
}
.v-list-item__title {
  color: rgb(140, 128, 207) !important;
}
/* .v-btn__content > span {
  color: rgb(119, 103, 209);
} */
</style>